export default __webpack_public_path__ + "static/desktop-bg-035f3013abc74c1ddad7890eb27705d1.png";